import { render, staticRenderFns } from "./about_us.vue?vue&type=template&id=2b928604&scoped=true&"
import script from "./about_us.vue?vue&type=script&lang=js&"
export * from "./about_us.vue?vue&type=script&lang=js&"
import style0 from "./about_us.vue?vue&type=style&index=0&id=2b928604&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b928604",
  null
  
)

export default component.exports